(() => {
  const WEBHOOK = 'https://services.leadconnectorhq.com/hooks/dV64fZ0ZW6pH1okIylAM/webhook-trigger/6b8ab76f-b976-464d-a536-353ce3563c24';

  const ordinal = (day) => {
    const mod100 = day % 100;
    if (mod100 >= 11 && mod100 <= 13) return 'th';
    if (day % 10 === 1) return 'st';
    if (day % 10 === 2) return 'nd';
    if (day % 10 === 3) return 'rd';
    return 'th';
  };

  const syncProductionDates = () => {
    const weekdays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];

    document.querySelectorAll('[data-production-date]').forEach((element) => {
      const productionDate = new Date();
      productionDate.setHours(productionDate.getHours() + 48);
      const day = productionDate.getDate();
      element.textContent = `${weekdays[productionDate.getDay()]} ${months[productionDate.getMonth()]} ${day}${ordinal(day)}`;
      element.setAttribute('datetime', `${productionDate.getFullYear()}-${String(productionDate.getMonth() + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`);
    });
  };

  const ensureProductionStrip = () => {
    document.querySelectorAll('[data-smash-pdp] .scpdp__buy').forEach((buy) => {
      const addToCart = buy.querySelector('add-to-cart-component');
      if (!addToCart) return;

      let strip = buy.querySelector('[data-production-strip]');
      if (!strip) {
        strip = document.createElement('div');
        strip.className = 'scpdp__production-strip';
        strip.dataset.productionStrip = 'true';
        strip.setAttribute('aria-label', 'Design and local production timing');
        strip.innerHTML = `
          <span class="scpdp__production-item scpdp__production-item--design">
            <span class="scpdp__production-dot" aria-hidden="true"></span>
            <span>Designed By <strong><time data-production-date>within 48h</time></strong></span>
          </span>
          <span class="scpdp__production-item scpdp__production-item--local">
            <span class="scpdp__production-flag" role="img" aria-label="United States flag">🇺🇸</span>
            <span>Local Production</span>
          </span>
        `;
      }

      if (strip.previousElementSibling !== addToCart) {
        addToCart.insertAdjacentElement('afterend', strip);
      }
    });

    syncProductionDates();
  };

  const syncSleeveLabel = (root) => {
    if (!root) return;
    const label = root.querySelector('[data-sleeve-label]');
    const yesButton = root.querySelector('[data-sleeve-choice="Yes"]');
    if (!label || !yesButton) return;

    const yes = yesButton.classList.contains('is-selected') || yesButton.getAttribute('aria-pressed') === 'true';
    label.innerHTML = yes
      ? 'Yes <span class="scpdp__sleeve-inline-price">+$13.99</span>'
      : 'No';
  };

  const syncAllSleeves = () => {
    document.querySelectorAll('[data-smash-pdp]').forEach(syncSleeveLabel);
  };

  const syncUi = () => {
    syncAllSleeves();
    ensureProductionStrip();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncUi, { once: true });
  } else {
    syncUi();
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-sleeve-choice]');
    if (!button) return;
    const root = button.closest('[data-smash-pdp]');
    requestAnimationFrame(() => syncSleeveLabel(root));
  });

  document.addEventListener('shopify:section:load', syncUi);

  const makeGhlPayload = (email) => {
    const query = new URLSearchParams(window.location.search);
    return new URLSearchParams({
      email,
      source: 'Smash Club Footer Newsletter',
      tags: 'newsletter, smash-footer',
      page_url: window.location.href,
      page_path: window.location.pathname,
      referrer: document.referrer || '',
      marketing_consent: 'email',
      utm_source: query.get('utm_source') || '',
      utm_medium: query.get('utm_medium') || '',
      utm_campaign: query.get('utm_campaign') || '',
      utm_content: query.get('utm_content') || '',
      utm_term: query.get('utm_term') || ''
    });
  };

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('form.sc-footer__signup');
    if (!form) return;

    const emailInput = form.querySelector('input[type="email"][name="contact[email]"]');
    const submitButton = form.querySelector('button[type="submit"]');
    const email = (emailInput?.value || '').trim();

    if (!emailInput || !email || !emailInput.checkValidity()) {
      emailInput?.reportValidity();
      return;
    }

    form.classList.add('is-submitting');
    form.querySelector('.sc-footer__ajax-error')?.remove();

    if (submitButton) {
      submitButton.disabled = true;
      submitButton.textContent = 'JOINING…';
    }

    fetch(WEBHOOK, {
      method: 'POST',
      mode: 'no-cors',
      body: makeGhlPayload(email),
      keepalive: true
    }).catch(() => null);

    // Important: do NOT prevent the native Shopify form submission here.
    // Shopify now handles the POST + redirect itself, which avoids false
    // "couldn't join" errors inside theme preview while preserving the real result.
  });

  window.addEventListener('pageshow', () => {
    document.querySelectorAll('form.sc-footer__signup').forEach((form) => {
      form.classList.remove('is-submitting');
      const button = form.querySelector('button[type="submit"]');
      if (button) {
        button.disabled = false;
        if (button.textContent.trim() === 'JOINING…') button.textContent = 'JOIN →';
      }
    });
  });
})();
